import React from 'react';
import convert from 'htmr';
import { Link, animateScroll as scroll } from 'react-scroll';

class FAQ extends React.Component {
  state = {
    isActiveId: ''
  };

  scrollToTop = () => {
    scroll.scrollToTop();
  };

  addActiveClass = (e, id) => {
    e.preventDefault();
    this.setState({
      isActiveId: id
    });
  };

  render() {
    const { faqs } = this.props;

    const firstFaqs = faqs.slice(0, 20);
    const safetyFaqs = faqs.slice(20, 27);

    return (
      <div className="row">
        <div className="col">
          <div className="faq__questions">
            {firstFaqs.map((faq) => {
              return (
                <React.Fragment key={faq.id}>
                  <Link to={faq.id.toString()} smooth={true}>
                    {faq.question}
                  </Link>
                </React.Fragment>
              );
            })}
            <p className="bold">MOTORCYCLE SAFETY FOUNDATION COURSE</p>
            {safetyFaqs.map((faq) => {
              return (
                <React.Fragment key={faq.id}>
                  <Link to={faq.id.toString()} smooth={true}>
                    {faq.question}
                  </Link>
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <div className="col">
          <div className="faq__list">
            {firstFaqs.map((faq) => {
              return (
                <div className="faq__item" key={faq.id}>
                  <button
                    className="question"
                    id={faq.id}
                    onClick={(e, id) => this.addActiveClass(e, faq.id)}
                    onKeyDown={(e, id) => this.addActiveClass(e, faq.id)}
                    rel="noopener noreferrer"
                  >
                    {faq.question}
                  </button>
                  <div className={`answer ${this.state.isActiveId === faq.id ? 'active' : ''}`}>
                    {convert(faq.answer)}
                  </div>
                </div>
              );
            })}

            <p className="bold">MOTORCYCLE SAFETY FOUNDATION COURSE</p>

            {safetyFaqs.map((faq) => {
              return (
                <div className="faq__item" key={faq.id}>
                  <button
                    className="question"
                    id={faq.id}
                    onClick={(e, id) => this.addActiveClass(e, faq.id)}
                    onKeyDown={(e, id) => this.addActiveClass(e, faq.id)}
                    rel="noopener noreferrer"
                  >
                    {faq.question}
                  </button>
                  <div className={`answer ${this.state.isActiveId === faq.id ? 'active' : ''}`}>
                    {convert(faq.answer)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default FAQ;
